module.exports = __webpack_public_path__ + "static/img/icon_help.9af7dde7.png";